import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import moment from 'moment'

import { Member, Role, userContextMenu } from 'react-wot-bootstrap'

import {
    getCustomDateTime,
    getTodayTime,
    getYesterdayTime,
    isTodayDay,
    isYesterdayDay,
 } from 'helpers/datetime'

import {
    TOOLTIP_IDS,
    GROUP_LIST,
} from '../../constants'

import styles from './CopyrightInfo.scss'

export const CopyrightInfo = props => {
    const onContextMenu = () => {
        userContextMenu(props.author_id, props.author_name)
    }

    let time = moment(props.created_at * 1000)
    if (isTodayDay(time)) {
        time = getTodayTime(time)
    } else if (isYesterdayDay(time)) {
        time = getYesterdayTime(time)
    } else {
        time = getCustomDateTime(time)
    }

    const memberStatusClassNames = classNames(
        styles.memberStatus,
        styles[`memberStatus__${props.author_status}`],
        props.author_is_friend && styles.memberStatus__isFriend,
    )

    const timeClassNames = classNames(
        styles.time,
        props.timeClassName,
    )

    return (
        <div className={styles.base}>
            {props.author_role && (
                <span data-tip data-for={`${TOOLTIP_IDS.AUTHOR_ROLE}${props.message_id}`}>
                    <Role role={props.author_role} />
                </span>
            )}
            <span
                className={memberStatusClassNames}
                onContextMenu={onContextMenu}
                data-tip data-for={props.author_role ? null : TOOLTIP_IDS.OUT_OF_CLAN}
            >
                <Member
                    name={props.author_name}
                    isOwn={props.author_id === props.accountId}
                />
            </span>
            <span className={timeClassNames}>
                {time}
            </span>
            {props.group_type === GROUP_LIST.COMMAND_STAFF && (
                <span
                    className={styles.lock}
                    data-tip data-for={TOOLTIP_IDS.LOCKED_ANNOUNCEMENT}
                />
            )}
        </div>
    )
}

CopyrightInfo.propTypes = {
    message_id: PropTypes.number.isRequired,
    created_at: PropTypes.number.isRequired,
    author_id: PropTypes.number.isRequired,
    author_name: PropTypes.string.isRequired,
    author_status: PropTypes.string.isRequired,
    accountId: PropTypes.number.isRequired,

    author_role: PropTypes.string,
    author_is_friend: PropTypes.bool,
    group_type: PropTypes.string,
    timeClassName: PropTypes.string,
}



// WEBPACK FOOTER //
// ./containers/ClanLanding/components/AnnouncementsCard/components/CopyrightInfo/CopyrightInfo.jsx